module.exports = __webpack_public_path__ + "img/table-addra-icon-white.9cf53332.svg";